import "@blockly/field-dependent-dropdown";
import * as Blockly from "blockly";
import { FieldChevronBase } from "./field-chevron-base.ts";
import { FieldIconBase } from "./field-icon-base.ts";
import { FieldJsonModalBase } from "./field-json-modal-base.ts";
import { FieldMultilineModalBase } from "./field-multiline-modal-base.ts";
import { FieldPlusMinusBase } from "./field-plus-minus-base.ts";
import { FieldVariableActionsBase } from "./field-variable-actions-base.ts";

export const BLOCKLY_FIELD_NAMES = [
  "field_icon",
  "field_chevron",
  "field_json_modal",
  "field_multiline_modal",
  "field_variable_actions",
  "field_plus_minus",
  "field_dependent_dropdown"
] as const;

export type FieldName = typeof BLOCKLY_FIELD_NAMES[number];
export type FieldClass = Blockly.fieldRegistry.RegistrableField;

const defaultFieldClasses = {
  field_icon: FieldIconBase,
  field_chevron: FieldChevronBase,
  field_json_modal: FieldJsonModalBase,
  field_multiline_modal: FieldMultilineModalBase,
  field_variable_actions: FieldVariableActionsBase,
  field_plus_minus: FieldPlusMinusBase
} satisfies Partial<Record<FieldName, FieldClass>>;

export function registerBlocklyFields(fieldClasses: Partial<Record<FieldName, FieldClass>> = {}): void {
  const classes = { ...defaultFieldClasses, ...fieldClasses };
  for (const fieldName of BLOCKLY_FIELD_NAMES) {
    const fieldClass = classes[fieldName];
    if (!fieldClass) continue;
    registerFieldIfMissing(fieldName, fieldClass);
  }
}

function registerFieldIfMissing(fieldName: FieldName, fieldClass: FieldClass): void {
  try {
    if (Blockly.registry.hasItem(Blockly.registry.Type.FIELD, fieldName)) return;
    Blockly.fieldRegistry.register(fieldName, fieldClass);
  } catch (error) {
    if (isAlreadyRegisteredError(error)) return;
    throw error;
  }
}

function isAlreadyRegisteredError(error: unknown): boolean {
  return error instanceof Error && /already registered|has already been registered/i.test(error.message);
}
